import React from 'react';

export default function SectionHeader({ kicker, title, description, alignDesc = 'right' }) {
  return (
    <div className="mb-10 md:mb-14">
      <p className="mono text-[11px] tracking-[0.22em] text-[#ED2D5C]">{kicker}</p>
      <div className={`mt-4 md:mt-6 grid grid-cols-1 ${alignDesc === 'right' ? 'lg:grid-cols-2 gap-8' : ''}`}>
        <h2 className="font-display text-white text-[44px] sm:text-[64px] md:text-[84px] leading-[0.92]">
          {title}
        </h2>
        {description && (
          <p className="text-neutral-400 text-[15px] md:text-[16px] leading-relaxed max-w-[460px] lg:mt-3 lg:justify-self-end">
            {description}
          </p>
        )}
      </div>
    </div>
  );
}
